const blocksSimpleContent = document.querySelectorAll(".theeblock--simple-content.h-screen.justify-start");
if (blocksSimpleContent.length > 0) {
	blocksSimpleContent.forEach((block, index) => {
		const content = block.querySelector(".block-content");
		content.style.position = "sticky";
		content.style.top = "125px";
		const blockPadding = parseInt(window.getComputedStyle(block).paddingTop);
		const blockHeight = block.clientHeight - 2 * blockPadding;
		const contentHeight = content.clientHeight;
		let opacity = 1;
		window.addEventListener("scroll", (event) => {
			opacity = 1 - (1.75 * (content.offsetTop - blockPadding)) / (blockHeight - contentHeight);
			content.style.opacity = opacity;
		});
	});
}
